import { render, staticRenderFns } from "./bdd-pass-register.vue?vue&type=template&id=b0e8d690"
import script from "./bdd-pass-register.vue?vue&type=script&lang=js"
export * from "./bdd-pass-register.vue?vue&type=script&lang=js"
import style0 from "./bdd-pass-register.vue?vue&type=style&index=0&id=b0e8d690&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./bdd-pass-register.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports